import React, { useState, useEffect } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Modal, Button } from '../../canvasComponents/index';
// redux
import { useDispatch } from 'react-redux';
import { validateLoggedIn, logout } from '../../redux/Authentication/actions';
// scss
import '../../css/components/PopUps/PopUps.scss';
// messages
import messages from './message';

function IdealUserPopUp(props) {
  const { isClaimAutoSaved, currentPage } = props || null;
  // eslint-disable-next-line react/destructuring-assignment
  const timeout = props.timeout || 15 * 60000; // = 15 minutes
  const [remainingTime, setRemainingTime] = useState(timeout);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const { getRemainingTime, reset } = useIdleTimer({
    timeout,
  });

  const handleOnClickOkay = () => {
    dispatch(validateLoggedIn());
    reset();
    setOpen(false);
  };

  const handleLogout = () => {
    dispatch(logout());
    reset();
    setOpen(false);
  };

  const onRequestClose = () => {
    setOpen(false);
    reset();
  };

  useEffect(() => {
    setRemainingTime(getRemainingTime());
    setInterval(() => {
      setRemainingTime(getRemainingTime());
    }, 1000);
  }, [getRemainingTime]);

  useEffect(() => {
    // show pop up modal after 10 mintues of inactivity (15 - 10 = 5)
    if (remainingTime <= 5 * 60000 && remainingTime !== 0) {
      if (!open) {
        dispatch(validateLoggedIn());
        setOpen(true);
      }
    }
    // kick user after 15 mintues of inactivity
    if (remainingTime === 0) {
      dispatch(logout());
    }
  }, [remainingTime]);

  let message;
  if (currentPage === 1) { // On 'Start your claim' page
    message = messages.descriptionThree;
  } else if (isClaimAutoSaved) {
    message = messages.descriptionOne;
  } else {
    message = messages.descriptionTwo;
  }

  return (
    <Modal
      id="ideal_user_popUp"
      isOpen={open}
      ariaHideApp={false}
      onRequestClose={() => onRequestClose()}
    >
      <div className="modal-grid-adj">
        <div className="pop-up-title">
          <p><FormattedMessage {...messages.header} /></p>
        </div>
        <div>
          <span className="pop-up-text-bigger">
            <FormattedMessage {...message} />
          </span>
          <br />
          <div className="several-buttons-wrapper">
            <Button primary className="pop-up-btn" onClick={() => handleOnClickOkay()}>
              <FormattedMessage {...messages.okay} />
            </Button>
            <br />
            <Button className="black-underline-button" onClick={() => handleLogout()}>
              <FormattedMessage {...messages.logout} />
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default injectIntl(IdealUserPopUp);
